import * as React from "react";
import { IntlProvider } from "react-intl";
import { connect, Dispatch } from "react-redux";
import { Route } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";

import { Navbar } from "../../components/UI/Navbar";
import GeneratorEntity from "../../models/Generator";
import Profile from "../../models/Profile";
import { loadGens, loadProfileSettings } from "../../store/actions";
import { IState } from "../../store/reducer";
import { history } from "../../store/store";
import EditGenerator from "../generators/EditGenerator";
import GeneratorComponent from "../generators/GeneratorList";
import ProfileComponent from "../Profile";
import SidebarComponent from "../Sidebar";

import { addLocaleData } from "react-intl";
import * as locale_de from "react-intl/locale-data/de";
import * as locale_en from "react-intl/locale-data/en";
import * as locale_fi from "react-intl/locale-data/fi";
import { LogInfo } from "src/components/LogInformation/LogInfo";
import { Footer } from "src/components/UI/Footer";
import { showLogInfo } from "src/constants/profileSettings";
import Bugreport from "../../components/UI/Utilities/Bugreport/Bugreport";
import messages_de from "../../translations/de.json";
import messages_en from "../../translations/en.json";
import messages_fi from "../../translations/fi.json";

addLocaleData([...locale_en, ...locale_de, ...locale_fi]);

const messages = {
  de: messages_de,
  en: messages_en,
  fi: messages_fi,
};

// const language = navigator.language.split(/[-_]/)[0]; // language without region code
// const language = "en";

interface IProps {
  generators: GeneratorEntity[];
  profile: Profile;

  loadGenerators: () => void;
  loadProfile: () => void;
  toggleInfo: (bool: showLogInfo) => void;
}

export class MainComponent extends React.Component<IProps, {}> {

  // public if (language === 'Undefined'){
  //   language='en';
  //

  public componentWillMount() {
    this.props.loadGenerators();
    this.props.loadProfile();
  }

  public render() {
    const language = this.props.profile.appLanguage === undefined ? 'en' : this.props.profile.appLanguage
    return (
      <IntlProvider locale={language} messages={messages[language]}>
        <ConnectedRouter history={history}>
          <>
            {this.props.profile.showLogInfo === showLogInfo.true &&  <LogInfo dismiss={this.props.toggleInfo}/> }
            <Navbar />
            <section className="section">
              <div className="columns">
                <SidebarComponent />
                <div className="column">
                  <Route exact={true} path="/" component={GeneratorComponent} />
                  <Route exact={true} path="/edit/:id" component={EditGenerator} />
                  <Route exact={true} path="/profilesettings" component={ProfileComponent} />
                  <Route exact={true} path="/bugreport" component={Bugreport} />
                  <Route path="/generators" component={GeneratorComponent} />
                </div>
              </div>
            </section>
            <Footer />
          </>
        </ConnectedRouter>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state: IState) => {
  return {
    generators: state.gen.generators,
    profile: state.user.profile
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    loadGenerators: () => loadGens(dispatch),
    loadProfile: () => loadProfileSettings(dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainComponent);



// WEBPACK FOOTER //
// ./src/Containers/main/MainComponent.tsx